var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',[_c('keep-alive',{attrs:{"include":_vm.cacheViews}},[_c('router-view')],1)],1),_c('t-tabbar'),_c('bindPhone')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }